export function checkCookie(name) {
  const cookieDict = document.cookie
    .split(';')
    .map(x => x.split('='))
    .reduce((accum, current) => {
      accum[current[0].trim()] = current[1]
      return accum
    }, Object())

  if (cookieDict[name]) {
    return true;
  }

  return false
}
